import React, { useEffect, useState,useMemo } from "react";
import { Secured } from "../../component";
import { Permissions } from "../../Constantes/permissions.constants";
import services from "./services";
import { PageContainer } from "@ant-design/pro-layout";
import moment from "moment";
import {
  useTable,
  useSortBy,
  useFilters,
} from "react-table";
import ModalConfirmarRemocao from "./ModalConfirmarRemocao";

import {
  SettingOutlined,
} from "@ant-design/icons";
import "./style.less";
import { formatCpf } from "../../helper/util";
import {
  Form,
  Col,
  Card,
  Row,
  Button,
  Radio,
  message,
  Select,
  Input,
  Modal,
} from "antd";


import { DeleteOutlined,FileOutlined } from "@ant-design/icons";

import { useAsyncDebounce } from "react-table";

const Agendamento = () => {

  const [mostrarModal, setMostrarModal] = useState(false);
  const [colaboradorSelecionado, setColaboradorSelecionado] = useState(null);

  const [exportOption, setExportOption] = useState("pdf");

  const [form] = Form.useForm();

  const [colaboradores, setColaboradores] = useState([]);

  const [filters, setFilters] = useState([]);
  const [sortBy, setSortBy] = useState([]);

  /*useEffect(() => {

    services
      .getUsuariosParaBloqueio()
      .then((response) => {
        let colaboradores = response.data;
        Object.entries(colaboradores).forEach(
          ([key, value]) => (colaboradores[key].cpf = formatCpf(value.cpf))
        );
      setColaboradores(colaboradores);
      })
      .catch(console.error);
  }, []);*/

  /*React.useEffect(() => {

    form.setFieldsValue(valuesSchema);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [form, valuesSchema]);*/

  /*const DefaultColumnFilter = ({ column: { filterValue, setFilter } }) => {
    return (
      <input
        value={filterValue || ""}
        onChange={(e) => setFilter(e.target.value || undefined)}
        onClick={(e) => e.stopPropagation()} // evita ativar ordenação ao clicar
        placeholder={`Filtrar...`}
        style={{ width: "100%" }}
      />
    );
  };*/

  const DefaultColumnFilter = ({ column: { filterValue, setFilter } }) => {
    const [value, setValue] = useState(filterValue);
  
    const onChange = useAsyncDebounce((value) => {
      setFilter(value || undefined);
    }, 300);
  
    return (
      <input
        value={value || ""}
        onChange={(e) => {
          setValue(e.target.value);
          onChange(e.target.value);
        }}
        onClick={(e) => e.stopPropagation()}
        placeholder="Filtrar..."
        style={{ width: "100%" }}
      />
    );
  };

  const StatusFilter = ({ column: { filterValue, setFilter } }) => {
    return (
      <select
        value={filterValue || ""}
        onChange={(e) => setFilter(e.target.value || undefined)}
        onClick={(e) => e.stopPropagation()}
        style={{
          width: "100%",
          height: "30px",
        }}
      >
        <option value="">Todos</option>
        <option value="true">Já Bloqueado</option>
        <option value="false">Não Bloqueado</option>
      </select>
    );
  };

  const columns = useMemo(
    () => [
      {
        Header: "C.P.F",
        //accessor: "cpf",
        accessor: (row) => row.cpf?.replace(/^(\d{3})(\d{3})(\d{3})(\d{2})$/, "$1.$2.$3-$4"),
        Filter: DefaultColumnFilter,
        className: "text-center",
      },
      {
        Header: "Nome",
        accessor: "nome",
        Filter: DefaultColumnFilter,
        className: "text-center",
      },
      {
        Header: "Nome da Mãe",
        accessor: "nomeMae",
        Filter: DefaultColumnFilter,
        className: "text-center",
      },
      {
        Header: "Data de Aniversário",
        id: "dataNascimento",
        accessor: (row) => moment(row.dataNascimento).format("DD/MM/YYYY"),
        Filter: DefaultColumnFilter,
        className: "text-center",
      },
      {
        Header: "Status",
        accessor: "jaBloqueado",
        Filter: StatusFilter,
        className: "text-center",
      
        Cell: ({ value }) => (
          <span
            style={{
              color: value ? "red" : "#d4b106",
              fontWeight: "bold",
            }}
          >
            {value ? "Bloqueado" : "Não Bloqueado"}
          </span>
        ),
      
        filter: (rows, id, filterValue) => {
          if (!filterValue) return rows;
      
          return rows.filter((row) =>
            String(row.values[id]) === filterValue
          );
        },
      },
      {
        id: "acao",
        disableFilters: true,
        className: "text-center",
        Cell: ({ row }) => (
          <button className="btn btn-outline button-table"  onClick={() => handleRemove(row.original)}  title= "Remover da Lista">
            <DeleteOutlined style={{ color: "red" }} />
          </button>
        ),
      },
    ],
    []
  );

  const defaultColumn = useMemo(
    () => ({
      Filter: DefaultColumnFilter,
    }),
    []
  );

  const {
    getTableProps,
    getTableBodyProps,
    headerGroups,
    rows,
    prepareRow,
    setAllFilters,
  } = useTable(
    {
      columns,
      data: colaboradores,
      defaultColumn,

      autoResetFilters: false,
      autoResetSortBy: false,
    },
    useFilters,
    useSortBy
  );

  const handleRemove = (colaborador) => {
    setColaboradorSelecionado(colaborador);
    setMostrarModal(true);
  };

  const confirmarRemocao = () => {
    //console.log("Justificativa:", justificativa);
    setColaboradores((prev) =>
      prev.filter((c) => c.cpf !== colaboradorSelecionado.cpf)
    );
    setMostrarModal(false);
    message.success("Segurado " + colaboradorSelecionado.nome + " removido com sucesso");
  };  

  const resetTela = () => {
    form.resetFields(["mes", "ano"]);
    setColaboradores([]);             
    setFilters([]);                
    setSortBy([]);                   
    setAllFilters([]);                
  };

  const bloquear = () => {
    const listaBloqueio = rows.map((row) => row.original);

    /*const listaBloqueio = colaboradores.map((colaborador) => ({
      cpf: colaborador.cpf,
      nome: colaborador.nome,
      nomeMae: colaborador.nomeMae,
      dataNascimento : colaborador.dataNascimento,
      dataUltimoBloqueio : colaborador.dataUltimoBloqueio,
      dataNascimentoFormatada : colaborador.dataNascimentoFormatada,
      dataUltimoBloqueioFormatada : colaborador.dataUltimoBloqueioFormatada,
      idPessoa : colaborador.idPessoa
    }));*/

    if (!listaBloqueio || listaBloqueio.length === 0) {
      return message.error("Não possui nenhum segurado para ser bloqueado.");
    }
  
    services.efetuarBloqueio(exportOption, listaBloqueio)
      .then(blob => {
        const url = window.URL.createObjectURL(new Blob([blob]));
        const link = document.createElement('a');
        link.href = url;
  
        // Formatando a data como dd-MM-yyyy
        const now = new Date();
        const day = String(now.getDate()).padStart(2, '0');
        const month = String(now.getMonth() + 1).padStart(2, '0'); // mês começa do zero
        const year = now.getFullYear();
        const formattedDate = `${day}_${month}_${year}`;
  
        const fileExtension =
          exportOption === "pdf"
            ? "pdf"
            : exportOption === "csv"
            ? "csv"
            : "txt";

        const fileName = `bloqueio_${formattedDate}.${fileExtension}`;
  
        link.setAttribute('download', fileName);
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link); // limpa o DOM após o clique
        window.URL.revokeObjectURL(url); // libera o objeto blob
      }).then(() => {
        resetTela();
        //return services.getUsuariosParaBloqueio();
      })
      /*.then(response => {
        //setColaboradores(response.data);
      })*/
      .catch(err => {
        console.error('Erro ao efetuar bloqueio:', err);
        alert(err);
      });
  };


  const emitirRelatorioBloqueio = () => {
    const listaBloqueio = rows.map((row) => row.original);

    if (!listaBloqueio || listaBloqueio.length === 0) {
      return message.error("Não possui nenhum segurado para ser bloqueado.");
    }
  
    services.emitirRelatorioBloqueio(exportOption, listaBloqueio)
      .then(blob => {
        const url = window.URL.createObjectURL(new Blob([blob]));
        const link = document.createElement('a');
        link.href = url;
  
        // Formatando a data como dd-MM-yyyy
        const now = new Date();
        const day = String(now.getDate()).padStart(2, '0');
        const month = String(now.getMonth() + 1).padStart(2, '0'); // mês começa do zero
        const year = now.getFullYear();
        const formattedDate = `${day}_${month}_${year}`;
  
        const fileExtension =
          exportOption === "pdf"
            ? "pdf"
            : exportOption === "csv"
            ? "csv"
            : "txt";

        const fileName = `bloqueio_${formattedDate}.${fileExtension}`;
  
        link.setAttribute('download', fileName);
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link); // limpa o DOM após o clique
        window.URL.revokeObjectURL(url); // libera o objeto blob
      })/*.then(() => {
        resetTela();
        //return services.getUsuariosParaBloqueio();
      })*/
      .catch(err => {
        console.error('Erro ao efetuar bloqueio:', err);
        alert(err);
      });
  };

  const meses = [
    { label: "Janeiro", value: 1 },
    { label: "Fevereiro", value: 2 },
    { label: "Março", value: 3 },
    { label: "Abril", value: 4 },
    { label: "Maio", value: 5 },
    { label: "Junho", value: 6 },
    { label: "Julho", value: 7 },
    { label: "Agosto", value: 8 },
    { label: "Setembro", value: 9 },
    { label: "Outubro", value: 10 },
    { label: "Novembro", value: 11 },
    { label: "Dezembro", value: 12 },
  ];

  const buscar =async  () => {
    const { mes, ano } = form.getFieldsValue();

    const values = await form.validateFields();
    if (!mes || !ano) {
      return message.warning("Informe mês e ano");
    }
  
    services
      .getUsuariosParaBloqueio(mes, ano)
      .then((response) => {
        let colaboradores = response.data;
  
        Object.entries(colaboradores).forEach(
          ([key, value]) =>
            (colaboradores[key].cpf = formatCpf(value.cpf))
        );
  
        setColaboradores(colaboradores);
      })
      .catch(console.error);
  };

  const confirmarBloqueio = () => {
    Modal.confirm({
      title: "Confirmar bloqueio",
      content: "Deseja realmente efetuar o bloqueio dos segurados? Após confirmação os segurados serão bloqueados,Deseja prosseguir?",
      okText: "Sim",
      cancelText: "Não",
      okType: "primary",

      onOk() {
        bloquear();
      },
    });
  };

  
  const confirmarImpressao = () => {
    Modal.confirm({
      title: "Confirmação de Impressão",
      content: "Atenção: esta ação não realiza o bloqueio dos segurados. Será gerado apenas um documento para controle. Deseja prosseguir?",
      okText: "Sim",
      cancelText: "Não",
      okType: "primary",

      onOk() {
        emitirRelatorioBloqueio();
      },
    });
  };
  
  return (
    <>
 
        <PageContainer>
        <Secured
        hasAnyRole={Permissions.RECADASTRAMENTO.TELA}
        isShowErro403={true}
        >
          <h1>Bloqueios</h1>
          <Form layout="vertical" form={form}>
          <Card title="Segurados a Serem Bloqueados">

              <Row gutter={16}>
                <Col span={6}>
                  <Form.Item
                    name="mes"
                    label="Mês"
                    rules={[{ required: true, message: "Informe o mês" }]}
                  >
                    <Select placeholder="Selecione o mês">
                      {meses.map((mes) => (
                        <Select.Option key={mes.value} value={mes.value}>
                          {mes.label}
                        </Select.Option>
                      ))}
                    </Select>
                  </Form.Item>
                </Col>

                <Col span={6}>
                  <Form.Item
                    name="ano"
                    label="Ano"
                    dependencies={["mes"]}
                    rules={[
                      { required: true, message: "Informe o ano" },
                      ({ getFieldValue }) => ({
                        validator(_, value) {
                          const mes = getFieldValue("mes");

                          if (!mes || !value) {
                            return Promise.resolve();
                          }

                          const hoje = new Date();
                          const dataAtual = new Date(hoje.getFullYear(), hoje.getMonth(), 1);
                          const limite = new Date(hoje.getFullYear(), hoje.getMonth() - 2, 1);
                          const dataInformada = new Date(value, mes - 1, 1);

                          if (dataInformada > limite) {
                            return Promise.reject(
                              new Error("Só é permitido informar até 2 meses anteriores ao atual")
                            );
                          }

                          return Promise.resolve();
                        },
                      }),
                      {
                        validator: (_, value) => {
                          if (!value) return Promise.resolve();
                  
                          if (value < 1900) {
                            return Promise.reject(new Error("Ano inválido"));
                          }
                  
                          return Promise.resolve();
                        },
                      },
                    ]}
                  >
                    <Input type="number" placeholder="Ex: 2025" />
                  </Form.Item>
                </Col>

                <Col span={6}>
                  <Form.Item label=" ">
                    <Button type="primary" onClick={buscar} style={{ width: "100%" }}>
                      Buscar
                    </Button>
                  </Form.Item>
                </Col>
              </Row>
          
              <Row>
                <div className="col-lg-12">
                  <div className="panel panel-default">
                    <div className="panel-body">
                      <div style={{ maxHeight: "500px", overflowY: "auto" }}>
                        <table {...getTableProps()} className="table table-striped">
                          <thead>
                          {headerGroups.map((headerGroup) => (
                            <tr {...headerGroup.getHeaderGroupProps()} key={headerGroup.id}>
                              {headerGroup.headers.map((column) => (
                                <th
                                  {...column.getHeaderProps(column.getSortByToggleProps())} className={column.className} 
                                  style={{
                                    position: "sticky",
                                    top: 0,
                                    background: "#fff",
                                    zIndex: 1,
                                  }}
                                >
                                  {column.render("Header")}
                                  <span>
                                    {column.isSorted ? (column.isSortedDesc ? " 🔽" : " 🔼") : ""}
                                  </span>
                                  <div>
                                    {colaboradores.length > 0 && column.canFilter ? column.render("Filter") : null}
                                  </div>
                                </th>
                              ))}
                            </tr>
                          ))}
                          </thead>
                          <tbody {...getTableBodyProps()}>
                            {rows.length > 0 ? (
                              rows.map((row) => {
                                prepareRow(row);
                                return (
                                  <tr {...row.getRowProps()} key={row.id}>
                                    {row.cells.map((cell) => (
                                      <td {...cell.getCellProps()}  className={cell.column.className}  style={{ textAlign: "center" }}>{cell.render("Cell")}</td>
                                    ))}
                                  </tr>
                                );
                              })
                            ) : (
                              <tr>
                                <td colSpan={columns.length} className="text-center">
                                  Não possui segurado(s) para bloqueio.
                                </td>
                              </tr>
                          )}
                          </tbody>
                        </table>
                      </div>
                    </div>
                  </div>
                </div>

                <div className="col-lg-12" style={{ 
                        marginTop: "12px", 
                        display: "flex", 
                        alignItems: "center", 
                        gap: "8px", // menor espaço
                        flexWrap: "wrap" // evita quebrar feio em telas menores
                      }}>
                  <Col style={{ flex: "none" }}>
                    <Radio.Group
                      onChange={(e) => setExportOption(e.target.value)}
                      value={exportOption}
                    >
                      <Radio value="pdf"><b>Gerar PDF</b></Radio>
                      <Radio value="csv"><b>Gerar Excel</b></Radio>
                      <Radio value="txt"><b>Gerar TXT</b></Radio>
                    </Radio.Group>
                  </Col>
                  <Col style={{ flex: "none" }}>
                    <Button
                    type="primary"
                    onClick={confirmarBloqueio}
                    disabled={ !colaboradores|| colaboradores.length == 0}
                    icon={<SettingOutlined />}
                  >Gerar Bloqueio
                  </Button>
                  </Col>

                  <Col style={{ flex: "none" }}>
                    <Button
                      className="btn-warning-custom"
                      onClick={confirmarImpressao}
                      disabled={!colaboradores || colaboradores.length === 0}
                      icon={<FileOutlined />}
                    >
                      Imprimir Relatório de Bloqueio
                    </Button>
                  </Col>
                </div>

                
              </Row>
              
          </Card>
          </Form>
          </Secured>
        <ModalConfirmarRemocao
          visible={mostrarModal}
          colaborador={colaboradorSelecionado}
          onCancel={() => setMostrarModal(false)}
          onConfirm={confirmarRemocao}
        />
        </PageContainer>
   
    </>
  );
};

export default Agendamento;
